import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-zinc-50 dark:bg-[#030303] text-zinc-900 dark:text-white transition-colors duration-500 overflow-x-hidden">
            <Navbar />
            <main>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default PublicLayout;
